export default __webpack_public_path__ + "static/media/NoRacesMascot.764bbc59.png";